/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import '../styles/css/payment-data.css';
import { Button, Radio, Segment, Form, Container, Header, Checkbox, Popup, Grid, Icon } from 'semantic-ui-react';
import CreditCard from './credit-card-format';
import ACH from './ach-format';

class PaymentData extends Component {
  constructor() {
    super();
    this.state = {
      values: [],
      moreThanOne: false, 
    }
  }

  handleSubmit = () => {
    this.props.storeProgressData(8, true)
  }

  handleSkip = () => {
    this.props.storeProgressData(8, false)
  }

  render() {

    const { node, open, ach, creditCard, payPal } = this.state
    const data = this.props
    const style = {
      container: {
        borderRadius: 0,
      },
      radio: {
        fontWeight: '200 !important'
      }
    }

    return (
      <div>
        <Segment padded='very' className="signup-form payment-container" raised>
          <Form onSubmit={this.handleSubmit} className="payment-data-form">
            <Header as='h1'>Payment Information</Header>
              <center>
                {this.props.data.map((item, i) => (
                  item.paymentType === 'ACH INFORMATION' ?

                      <ACH data={item} index={i} count={this.props.count}/>

                    :

                    item.paymentType === 'CREDIT CARD' ?

                        <CreditCard data={item} index={i} count={this.props.count}/>

                      :

                      null

                ))}

                <Icon onClick={this.props.backToPaymentPage} name="add" circular color="blue" className="add-ach-payment" size='big' />
              </center>
          </Form>

          <div className="payment-buttonRow">
            <Button type='submit' className="payment-cancel">CANCEL</Button>
            <Button type='submit' className="payment-skip" onClick={this.handleSkip}>SKIP THIS</Button>
            <Button onClick={this.handleSubmit} type='submit' className="payment-save" color="twitter">SAVE & NEXT</Button>
          </div>
        </Segment>

      </div>
    );
  }
}

export default PaymentData;